import styled from 'styled-components'

export const SearchContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  align-items: flex-end;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const AutoCompleteWrapper = styled.div`
  flex: 1;

  @media (max-width: 768px) {
    ul {
      max-height: 96px;
    }
  }
`

export const QuantityWrapper = styled.div`
  width: 120px;

  @media (max-width: 768px) {
    width: 100%;
  }
`
